'use strict';

const trackingUtils = require('../utils/tracking.utils');
const flightChangeFreeUtil = require('../../modules/utils/flight_change_free');
const SavingAlertView = require('./saving_alert.view.js');
const MIN_PRICE_FONT_SIZE = 14;
let isPayWithGuarantee = false;
let hideTotalPrice = false;
const insuranceCatalogueCollection = require('../../modules/collections/insurance_catalogue.collection').getInstance();
const flowTrackingDefinition = require('../utils/flow_tracking/tracking.definition');

module.exports = Odigeo.View.extend({
    preSelectedServicePrice: 0,
    seatSelection: null,
    seatMapSelection: null,
    currency: null,
    isPriceWithoutDiscountSelected: false,
    preselectedServiceOption: null,
    lastTalPricesContainerWidth: 0,
    template: null,
    pricebreakdownTemplate: null,
    priceSummaryTemplate: null,
    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },
    selectors: {
        refundableTaxesBlock: '.refundable_taxes_section',
        refundableTaxesPrice: '.refundable_price',
        payWithGuaranteeContainer: '.pay_with_guarantee_container',
        pwgConditionsLinkMoved: '.pwg_conditions_link_moved',
        pwgConditionsLink: '.pwg_conditions_link',
        tableColumn: '.pricebreakdown_table_column',
        priceColumn: '.pricebreakdown_price_column',
        paymentButton: '.payment_continue_button',
        priceWithoutGuarantee: '.pay_without_guarantee_price',
        totalPriceTemplate: '.totalprice_template',
        payWithGuaranteeTotalPrice: '.pay_with_guarantee_total_price',
        paymentButtonsBox: '.payment_buttons_box',
        pricebreakdownContainer: '.pricebreakdown_container',
        totalPricesContainer: '.price_total',
        savingAlertWrapper: '.saving_alert_wrapper',
        savingAlertsTemplate: '.saving_alert_template',
        priceSummaryTaxInfo: '.price_summary_tax_info',
        priceSummaryPopup: '.price_summary_popup',
        priceSummaryLink: '.price_summary_link',
        priceSummaryHint: '.price_summary_hint',
        pwgConditionsLinkMovedClicked: '.pwg_conditions_pdf_link_moved',
        freeCanxTitle: '.od-payment-manager-free-canx-title',
        freeCanxTooltip: '.od-payment-manager-free-canx-tooltip',
        stepButtonChangeFlightFreeChargeContainerText: '.flights_change_free_message',
        airlineCampaignContainer: '.airline_campaign_payment',
        continueButtonContainer: '.continue_button_container',
        autoApplyDiscountContainer: '.auto_apply_discount_container',
        membershipFlexibilityPaymentLabel: '.membership_flexibility_payment_label',
        membershipFlexibilityPaymentTooltipFullFare: '.membership_flexibility_payment_tooltip_full_fare',
        membershipFlexibilityPaymentTooltipPrimeFare: '.membership_flexibility_payment_tooltip_prime_fare',
    },
    events: {
        'tap .pricebreakdown_content': 'clickHandler',
        'tap .pricebreakdown_toggle': 'onPriceBreakdownToggleClicked',
        'tap .od_pr-details': 'onToggleExpandable',
        'tap @paymentButton': 'onContinueButtonClicked',
        'tap .agree_conditions_folded': 'onAgreeConditionsFoldedClicked',
        'tap .open_agree_conditions': 'onNewConditionsClicked',
        'tap .tracking_policy a': 'onTrackingPolicyClicked',
        'tap .conditions_section_title': 'onShowConditionsSectionTitle',
        'mouseover  @paymentButton': 'onContinueButtonMouseover',
        'mouseover .price_summary_tax_info': 'onTaxInfoMouseover',
        'mouseleave .price_summary_tax_info': 'onTaxInfoMouseLeave',
        'tap @pwgConditionsLinkMovedClicked': 'onPwgConditionsLinkMovedClicked',
    },

    init: function() {
        this.widget.options = Odigeo.parseOptions(this.widget.options);
        this.templates = Odigeo.Utils.getTemplates(this.$el, {
            priceWithoutGuaranteRepricing: '#price_without_guarantee_repricing',
        }, this.templateSettings);
        this.bindEvents();
        this.setVariables();
        this.initPriceBreakdownTemplate();
        this.hideSelectedCcIfIsPriceWithoutDiscount();
        this.setSeatsLeft();
        this.setSavingAlert();
    },

    bindEvents: function() {
        this.bindGeneralEvents();
        this.bindPriceEvents();
        this.listenTo(this.model, 'renderAgreeConditions', this.renderAgreeConditions);
    },

    renderAgreeConditions: function(msg) {
        this.$el.find('.payment_agree').html(msg);

        if (this.hasPopupPaymentCondition()) {
            this.enhancePaymentConditionsHint();
        }

        if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking')) &&
            this.checkIfFlightHasInsurance()) {
            this.$el.find('.pba_flight_insurances_disclaimer').removeClass('odf-hidden');
        }

        if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
            this.$cachedSelectors.priceSummaryHint.addClass('odf-hidden');
        }

        this.bindAgreeConditionsEvents();
    },

    checkIfFlightHasInsurance: function() {
        return Odigeo.Utils.parseJson(Odigeo.Session.storage.bookingInfo).insuranceBookings.bookings.length > 0;
    },

    checkIfOfferPricesTextSizeShouldBeResized: function() {
        var currentWidth = this.$cachedSelectors.totalPricesContainer.width();
        if (this.lastTalPricesContainerWidth !== currentWidth) {
            this.lastTalPricesContainerWidth = currentWidth;
            this.refreshOfferPricesTextSize();
        }
    },

    refreshOfferPricesTextSize: function() {
        this.$el.find('.resizable_text').each(Odigeo._.bind(function(index, element) {
            var $element = $(element);
            var defSize = +($element.data('defSize'));

            if (!Odigeo._.isNumber(defSize) || Odigeo._.isNaN(defSize)) {
                defSize = parseInt($element.css('font-size'));
                $element.data('defSize', defSize);
            }

            var $parent = $element.closest('.resizable_text_container');
            $element.css('font-size', defSize + 'px');
            var currentFontSize = defSize;

            while ($parent.width() && this.checkOfferPriceTextVsContainerWidth($element) > $parent.width() && currentFontSize > MIN_PRICE_FONT_SIZE) {
                currentFontSize -= 2;
                $element.css('font-size', (currentFontSize) + 'px');
            }
        }, this));
    },

    checkOfferPriceTextVsContainerWidth: function(em) {
        var $em = $(em);
        var oldPosition = $em.css('position');
        var width;

        $em.css('position', 'absolute');
        width = $em.width();
        $em.css('position', oldPosition);
        return width;
    },

    bindAgreeConditionsEvents: function() {
        if (this.hasPopupPaymentCondition()) {
            this.$el.find('.conditions_section_title').on(Odigeo.Events.tap, Odigeo._.bind(function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (this.hasPopupPaymentCondition()) {
                    this.$el.find('div[class^="conditions_section_content_"]').addClass('hidden', true);
                    this.$el.find('.conditions_section_content_' + $(e.currentTarget).data('layer')).removeClass('hidden');
                }
            }, this));
        }

        if (this.widget.options.isCollapsive) {
            this.setUpCollapsiblePanel();
        }
    },

    bindPriceEvents: function() {
        this.listenTo(this.model, 'updatePrices', this.repaintPrices);
        this.listenTo(this.model, 'render', this.renderView);
        this.listenTo(this.model, 'change:repricing', this.renderTotalPriceSection);
    },

    bindGeneralEvents: function() {
        var priceDetails = this.$el.find('.pricemanager_info');
        var priceSummaryHint = this.$el.find('.price_summary_hint');

        if (priceDetails.length > 0) {
            Odigeo.UIElements.enhanceExpandable(priceDetails, {selfClose: false});
        }

        if (priceSummaryHint.length > 0) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), priceSummaryHint, {
                events: {
                    tap: true,
                },
                googleAnalyticsOnOpen: {
                    type: 'trackEvent',
                    data: {
                        page: Odigeo.History.getPageNameFromFragment(),
                        action: 'trip_information',
                        label: 'open_price_breakdown',
                    },
                },
            });
        }
    },

    setUpCollapsiblePanel: function() {
        var priceManagerExpandable = this.$el.find('.pricemanager_expandable');
        var isFolded = this.widget.options.isFolded;

        this.$el.find('.pricebreakdown_toggle_container').toggleClass('hidden', !isFolded);

        Odigeo.UIElements.collapsive.enhance(priceManagerExpandable, {
            triggerLauncher: 'priceManagerExpandable',
        });

        priceManagerExpandable.trigger(
            isFolded ? 'collapsePanel' : 'expandPanel'
        );

        this.moveAgreeCheckbox(isFolded);

        this.$cachedSelectors.pricebreakdownContainer.toggleClass('expanded', !isFolded);
        priceManagerExpandable.on('expanded onCollapse', Odigeo._.bind(function() {
            Odigeo.trigger(this.widget.id + ':priceBreakdownToggled');
        }, this));
    },

    moveAgreeCheckbox: function(open) {
        var $agreeCheckboxFolded = this.$el.find('.agree_checkbox_folded');
        var $agreeCheckboxFoldedSelectable = $agreeCheckboxFolded.find('.agree_selectable');
        var $agreeCheckboxUnfolded = this.$el.find('.agree_checkbox');
        var $agreeCheckboxUnfoldedSelectable = $agreeCheckboxUnfolded.find('.agree_selectable');
        var $agreeCheckboxFoldedOneButton = this.$el.find('.agree_cond_one_button .agree_checkbox_folded');
        var $agreeCheckboxUnfoldedOneButton = this.$el.find('.agree_cond_one_button .agree_checkbox');
        var $agreeCheckboxFoldedTwoButtons = this.$el.find('.agree_cond_two_buttons .agree_checkbox_folded');
        if (open) {
            $agreeCheckboxUnfoldedSelectable.appendTo($agreeCheckboxFoldedOneButton);
            $agreeCheckboxUnfoldedSelectable.appendTo($agreeCheckboxFoldedTwoButtons);
        } else {
            $agreeCheckboxFoldedSelectable.appendTo($agreeCheckboxUnfoldedOneButton);
            $agreeCheckboxFoldedSelectable.appendTo($agreeCheckboxFoldedTwoButtons);
            $agreeCheckboxUnfoldedSelectable.appendTo($agreeCheckboxFoldedTwoButtons);
        }
    },

    enhancePaymentConditionsHint: function() {
        Odigeo.UIElements.hint.enhance('payment', this.$el.find('.popUp_payment_conditions_hint'), {
            events: {
                tap: true,
            },
            googleAnalyticsOnOpen: {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'payment_details',
                    label: 'link_general_terms_and_conditions_open',
                },
            },
        });
    },

    hasPopupPaymentCondition: function() {
        return this.widget.options.hasPopupPaymentCondition
            && !Odigeo._.isEmpty(this.$el.find('.popUp_payment_conditions_hint'));
    },


    onTaxInfoMouseover: function() {
        this.togglePriceSummaryPopups(true, '.price_summary_tax_info_popup');
    },

    onTaxInfoMouseLeave: function() {
        this.togglePriceSummaryPopups(false, '.price_summary_tax_info_popup');
    },

    togglePriceSummaryPopups: function(shallBeShown, popup) {
        this.$el.find(popup).toggleClass('open opened', shallBeShown);
    },

    onAgreeConditionsFoldedClicked: function(e) {
        e.stopPropagation();
        if (this.hasPopupPaymentCondition()) {
            this.$el.find('.payment_agree').find('.popUp_payment_conditions_hint').trigger('toggle');
        }
    },

    onNewConditionsClicked: function(e) {
        e.stopPropagation();
        if (this.hasPopupPaymentCondition()) {
            this.$el.find('.popUp_payment_conditions_hint').trigger('toggle');
        }
    },

    onTrackingPolicyClicked: function(e) {
        e.stopPropagation();
        trackingUtils.trackEvent('payment_details', 'link_data_protection_policy_open');
    },

    initPriceBreakdownTemplate: function() {
        this.templateType = this.getTemplateName();
        this.priceSummaryTemplate = Odigeo._.template(this.$el.find('.priceSummaryTemplate').html(), this.templateSettings);
        this.pricebreakdownTemplate = Odigeo._.template(this.$el.find('.' + this.templateType).html(), this.templateSettings);
    },

    getTemplateName: function() {
        var templatePrefix = this.isTaxFee() ? 'taxfee' : '';
        var templateName = '';

        if (this.isNetTaxSeparatelyTemplateConfig()) {
            templateName = 'netTaxSeparately';
        } else if (this.isBestPriceConfigurationConfig()) {
            templateName = templatePrefix + 'bestPrice';
        } else if (this.isFullPriceFullTableConfig()) {
            templateName = templatePrefix + 'fullpriceFullTable';
        } else {
            templateName = templatePrefix + 'fullPrice';
        }

        return templateName;
    },

    isTaxFee: function() {
        return this.widget.options.pricebreakdownShowingTaxAndFee &&
            !this.widget.options.isDynpack && !this.widget.options.isUpsell;
    },

    isNetTaxSeparatelyTemplateConfig: function() {
        return this.widget.options.showNetTaxSeparately &&
            !this.widget.options.pricebreakdownShowingTaxAndFee;
    },

    isBestPriceConfigurationConfig: function() {
        return this.widget.options.isBestPriceConfigurationEnabled;
    },

    isFullPriceFullTableConfig: function() {
        return this.widget.options.isFullPriceConfigurationEnabled &&
            this.widget.options.fullTablePriceBreakDownOnFullPriceAtPayment;
    },

    repaintPrices: function(totalPrice, pricePerPax) {
        this.$el.find('.od-js-total-price').html(this.formatSeparatedDecimals(totalPrice)).data('total-price', totalPrice);
        this.$el.find('.od-js-total-pp-price').html(Odigeo.Utils.formatCurrency(pricePerPax));
    },

    formatSeparatedDecimals: function(valueToFormat) {
        var formattedValueParts = this.separateDecimals(valueToFormat);
        if (formattedValueParts.length > 1) {
            return $('<span>').append(formattedValueParts.integer)
                .add($('<span>', {'class': 'decimal'}).append(formattedValueParts.decimalSeparator + formattedValueParts.decimal));
        }
    },

    separateDecimals: function(number) {
        var decimalSeparator = Odigeo._.has(this.currency, 'decimalSeparator') ?
            this.currency.decimalSeparator : Odigeo.Utils.Currency.decimalSeparator;
        return ({
            decimalSeparator: decimalSeparator,
            integer: number.split(decimalSeparator)[0],
            decimal: number.split(decimalSeparator)[1],
        });
    },

    renderView(priceCollectionData) {
        this.renderTotalPriceSection(priceCollectionData);
        this.renderPriceBreakdownTemplate(Odigeo._.extend(priceCollectionData, {
            'insurance_fare_upgrades': this.getInsuranceFareUpgradesFormatted(priceCollectionData),
        }, this));
        this.showRefundableTaxes(priceCollectionData);
        if (insuranceCatalogueCollection.isRefundableFareUpgradeSetInPax() && Odigeo.AB.isFareC4ARinPaxEnabled) {
            this.hidePayWithGuarantee();
        }
    },

    getInsuranceFareUpgradesFormatted: function(priceCollectionData) {
        var insuranceFareUpgrades = this.getInsuranceFareUpgrades(priceCollectionData);

        return Odigeo._.map(insuranceFareUpgrades, function(item) {
            return Odigeo._.extend(item, {
                onePriceFormatted: Odigeo.Utils.formatCurrency(item.onePrice),
                allPriceFormatted: Odigeo.Utils.formatCurrency(item.allPrice),
            });
        });
    },

    getInsuranceFareUpgrades: function(priceCollectionData) {
        var insuranceList = this.getPreselectedInsurances();

        return Odigeo._.filter(priceCollectionData.items, function(insurance) {
            return Odigeo._.contains(insuranceList, insurance.id);
        });
    },

    getPreselectedInsurances: function() {
        var allInsurances = insuranceCatalogueCollection.isLoaded() ? insuranceCatalogueCollection.getInsurances() : {};
        var preselectedInsurances = Odigeo._.filter(allInsurances, function(insurance) {
            return insurance.preselected;
        });

        return Odigeo._.map(preselectedInsurances, function(insurance) {
            return insurance.policy;
        });
    },

    showRefundableTaxes: function(priceCollectionData) {
        this.$cachedSelectors.refundableTaxesBlock.toggleClass('odf-hidden', priceCollectionData.refundableTaxes === 0);
        if (priceCollectionData.refundableTaxes > 0) {
            this.$cachedSelectors.refundableTaxesPrice.html(priceCollectionData.refundableTaxesFormatted);
        }
    },

    renderTotalPriceSection: function(priceCollectionData) {
        var priceCollection = this.updateCcFee(priceCollectionData);
        var template = Odigeo._.template(this.$el.find('.totalPriceSection').html(), this.templateSettings)({
            options: this.widget.options,
            priceCollection: priceCollection,
            templateType: this.templateType,
            ccSelected: this.ccSelected,
        });
        this.$cachedSelectors.totalPriceTemplate.html(template);
        this.$cachedSelectors.priceWithoutGuarantee.html(this.model.getPriceWithoutGuaranteeFormatted());
        this.renderRepricing();
        Odigeo.trigger(this.widget.id + ':totalPriceUpdated', priceCollection);
        this.toggleTotalPriceContainer();
        if (Odigeo.Membership.isMembershipFlexibilityD) {
            this.updateMembershipFlexibilityLabelAndTooltip(priceCollectionData);
        } else {
            this.updateFreeCanxTextsVisibility();
        }
        this.showAirlineCampaign();
    },

    updateFreeCanxTextsVisibility() {
        insuranceCatalogueCollection.getLoadedPromise().then((loaded) => {
            if (loaded && insuranceCatalogueCollection.isCancellationFree()) {
                this.$cachedSelectors.freeCanxTitle.removeClass('odf-hidden');
                this.$cachedSelectors.freeCanxTooltip.removeClass('odf-hidden');
            }
            if (loaded && !insuranceCatalogueCollection.isCancellationFree()) {
                this.showChangeFlightFreeChargePaymentButtonText();
            }
        });
    },

    updateMembershipFlexibilityLabelAndTooltip(priceCollectionData) {
        const isMembershipSubscriptionAdded = Odigeo._.find(priceCollectionData.items, 'type', 'MEMBERSHIP_SUBSCRIPTION');
        const isMembershipOnPerks = !!isMembershipSubscriptionAdded ||
            priceCollectionData.membershipPerks.isMemberLoggedIn ||
            this.model.get('isAutoApplyDiscount');
        if (!isMembershipOnPerks && flightChangeFreeUtil.isSelectedFlightChangeableForFree()) {
            this.$cachedSelectors.membershipFlexibilityPaymentLabel.removeClass('odf-hidden');
            this.$cachedSelectors.membershipFlexibilityPaymentTooltipFullFare.removeClass('odf-hidden');
            this.$cachedSelectors.membershipFlexibilityPaymentTooltipPrimeFare.addClass('odf-hidden');
        } else if (isMembershipOnPerks) {
            this.$cachedSelectors.membershipFlexibilityPaymentLabel.addClass('odf-hidden');
            this.$cachedSelectors.membershipFlexibilityPaymentTooltipFullFare.addClass('odf-hidden');
            this.$cachedSelectors.membershipFlexibilityPaymentTooltipPrimeFare.removeClass('odf-hidden');
        } else {
            this.$cachedSelectors.membershipFlexibilityPaymentLabel.addClass('odf-hidden');
            this.$cachedSelectors.membershipFlexibilityPaymentTooltipFullFare.addClass('odf-hidden');
            this.$cachedSelectors.membershipFlexibilityPaymentTooltipPrimeFare.addClass('odf-hidden');
            this.updateFreeCanxTextsVisibility();
        }
    },

    showChangeFlightFreeChargePaymentButtonText() {
        const shouldShowFlightChangeFreeMessage =
            (Odigeo.AB.isChangeFlightFreeChargeDesktop || Odigeo.AB.isPrimeDays) &&
            flightChangeFreeUtil.isSelectedFlightChangeableForFree();
        if (shouldShowFlightChangeFreeMessage) {
            this.$cachedSelectors.stepButtonChangeFlightFreeChargeContainerText.removeClass('odf-hidden');
        }
    },

    showAirlineCampaign() {
        const campaignConfig = JSON.parse(Odigeo.Session.get('campaignConfig'));
        const hasPrimeDayCampaign = campaignConfig && campaignConfig.primeDayConfig && campaignConfig.primeDayConfig.isPrimeDayFare;
        const hasAirlineCampaign = campaignConfig && campaignConfig.airlineCampaignConfig && campaignConfig.airlineCampaignConfig.hasAirlineCampaign;
        const shouldShowAirlineCampaign = !this.widget.options.isDynpack && !hasPrimeDayCampaign && hasAirlineCampaign;
        if (shouldShowAirlineCampaign) {
            this.$cachedSelectors.airlineCampaignContainer.removeClass('odf-hidden');
        }
    },

    renderPriceWithOldPrice: function(price) {
        return this.templates.priceWithoutGuaranteRepricing({
            priceWithOffer: Odigeo.Utils.formatCurrency(price),
            repricing: this.model.get('repricing'),
        });
    },

    renderRepricing() {
        if (Odigeo._.isObject(this.model.get('repricing'))) {
            const price = this.model.get('repricing').newPrice;
            const $totalPriceSection = this.$cachedSelectors.totalPriceTemplate.find('.pricebreakdown_total_price');
            this.$cachedSelectors.priceWithoutGuarantee.html(this.renderPriceWithOldPrice(price));
            $totalPriceSection.data('total-price', price);
            $totalPriceSection.html(this.renderPriceWithOldPrice(price));
        }
    },

    renderPriceBreakdownTemplate: function(priceCollectionData) {
        const options = this.widget.options;
        const isMembershipPriceDisplay = this.isMembershipPriceDisplay(priceCollectionData, options);
        const priceCollectionWithMemberPerksUpdated = this.updateWithPerksInfo(priceCollectionData, options, isMembershipPriceDisplay);
        const isPriceSummary = Odigeo.Utils.isRequestApp('dp') || Odigeo.AB.isPriceSummaryDesktop;

        if (isPriceSummary) {
            const priceSummaryTemplate =
                this.priceSummaryTemplate(this.model.getPriceSummaryData(priceCollectionWithMemberPerksUpdated.membershipPerks));
            this.$el.find('.price_summary_template').html(priceSummaryTemplate);
        } else {
            this.renderOldPricebreakdown(priceCollectionData, options, isMembershipPriceDisplay);
        }
    },

    renderOldPricebreakdown: function(priceCollectionData, options, isMembershipPriceDisplay) {
        var template = this.pricebreakdownTemplate({
            options: options,
            priceCollection: this.updateWithPerksInfo(priceCollectionData, options, isMembershipPriceDisplay),
            segmentsTotalQuantity: options.numtravellers * options.numsegments,
            isTaxFee: this.isTaxFee(),
            pricebreakdownShowingTaxAndFee: options.pricebreakdownShowingTaxAndFee,
            pricebreakdownShowingRealProviderFare: options.pricebreakdownShowingRealProviderFare,
            preSelectedServiceOption: this.getPreselectedServiceOption(),
            texts: {ccFee: this.getCcFeeTexts(isMembershipPriceDisplay, options)},
        });
        this.$el.find('.pricebreakdown_template').html(template);
    },

    isMembershipIncluded: function(priceCollectionData) {
        return priceCollectionData.membershipPerks ? priceCollectionData.membershipPerks.isIncludedInPrice : false;
    },

    isMembershipPriceDisplay: function(priceCollectionData, options) {
        return this.isMembershipIncluded(priceCollectionData) || options.isMembershipDualPrice;
    },

    updateWithPerksInfo: function(pcData, options, isMembershipPriceDisplay) {
        var updateCcFee = Odigeo._.bind(this.updateCcFee, this);
        var addPerksDefaultValues = Odigeo._.partial(this.addPerksDefaultValues, _, isMembershipPriceDisplay);
        var updatePerksValues = Odigeo._.partial(this.addMembershipPerksValues, _, options, isMembershipPriceDisplay);
        return Odigeo._.flowRight(updatePerksValues, addPerksDefaultValues, updateCcFee)(pcData);
    },

    addPerksDefaultValues: function(pcData, isMembershipPriceDisplay) {
        var membershipPerks = pcData.membershipPerks;
        membershipPerks.membershipClass = '';
        membershipPerks.slashedClass = '';
        membershipPerks.isMembershipPriceDisplay = isMembershipPriceDisplay;
        membershipPerks.displayFee = 0;
        membershipPerks.disclaimerText = '';
        return pcData;
    },

    addMembershipPerksValues: function(pcData, options, isMembershipPriceDisplay) {
        var membershipPerks = pcData.membershipPerks;
        if (isMembershipPriceDisplay) {
            membershipPerks.membershipClass = 'od-pricebreakdown-membership-discount-fee';
            membershipPerks.displayFee = options.showFeesQuantityAlwaysOne ?
                membershipPerks.fee : (membershipPerks.fee / options.numtravellers);
            if (!membershipPerks.isIncludedInPrice) {
                membershipPerks.membershipClass = 'od-pricebreakdown-membership-discount-fee-warning od-membership-align-top';
                membershipPerks.slashedClass = 'odf-text-line-through';
                membershipPerks.disclaimerText = membershipPerks.isMemberLoggedIn ?
                    options.membershipDisclaimerDiscountNotBtwnTrav : options.membershipDisclaimerDiscountNotApplied;
            }
        }
        return pcData;
    },

    updateCcFee: function(pcData) {
        var membershipPerks = pcData.membershipPerks;
        const membershipSubscription = Odigeo._.find(pcData.items, 'type', 'MEMBERSHIP_SUBSCRIPTION');
        Odigeo.trigger(this.widget.id + ':updatePremiumSidebarView',
            Odigeo._.extend(membershipPerks, {
                membershipPrice: Odigeo._.result(membershipSubscription, 'onePrice'),
                isSubscriptionAdded: !!membershipSubscription,
            }));
        return this.isMembershipIncluded(pcData) ? this.widget.model.updateCcFee(membershipPerks) : pcData;
    },

    getCcFeeTexts: function(isMembershipPriceDisplay, options) {
        var disc = options.membershipDiscountText;
        var ccNeg = options.membershipCcTextNeg;
        var ccPos = options.membershipCcTextPos;
        return isMembershipPriceDisplay ? {pos: disc, neg: disc} : {pos: ccPos, neg: ccNeg};
    },

    getPreselectedServiceOption: function() {
        if (Odigeo._.isNull(this.preselectedServiceOption)) {
            this.preselectedServiceOption = this.$el.find('.pricebreakdown_content').data('preSelectedServiceOption');
        }

        return this.preselectedServiceOption;
    },

    setVariables: function() {
        var breakdown = this.$el.find('.od_pr-breakdown');
        var insuranceId = this.widget.model.getPriceBreakdownItemByType('INSURANCES').get('conceptKey');

        this.currency = breakdown.data('currency');
        this.isPriceWithoutDiscountSelected = this.$el.find('.pricebreakdown_content').data('isPriceWithoutDiscountSelected');

        if (Odigeo._.isEmpty(insuranceId)) {
            insuranceId = -1;
        }

        Odigeo.trigger(this.widget.id + ':checkSelectedInsuranceIfNotChecked', {
            insuranceId: insuranceId,
        });
    },

    hideSelectedCcIfIsPriceWithoutDiscount: function() {
        if (this.isPriceWithoutDiscountSelected) {
            this.$el.toggleClass('hidden-cctype', true);
        }
    },

    onToggleExpandable: function() {
        if (Odigeo._.isUndefined(this.widget.options.enhanceExpandable) || this.widget.options.enhanceExpandable) {
            this.$el.find('.pricemanager_info').trigger('toggleExpandable');
            this.showDetailsHandler();
        }
    },

    onPriceBreakdownToggleClicked: function() {
        if (this.widget.options.isCollapsive) {
            var container = this.$cachedSelectors.pricebreakdownContainer;
            var opened = container.hasClass('expanded');
            this.moveAgreeCheckbox(opened);

            this.$el.find('.pricemanager_expandable').trigger('togglePanel');

            container.toggleClass('expanded');

            if (!opened) {
                trackingUtils.trackEvent('trip_information', 'open_price_breakdown', Odigeo.History.getPageNameFromFragment());
            }
        }
    },

    onContinueButtonClicked: function() {
        Odigeo.trigger(this.widget.id + ':onContinueButtonClicked', {});
    },

    onContinueButtonMouseover: function() {
        Odigeo.trigger(this.widget.id + ':trackContinueButtonMouseover');
    },

    clickHandler: function() {
        Odigeo.trigger('complete', {'type': 'success', 'data': this.data, 'id': this.id});
    },

    showDetailsHandler: function() {
        var expandableToggleArea = this.$el.find('.od_pr-details');
        expandableToggleArea.find('.pricemanager_toggle_title_show').toggleClass('hidden');
        expandableToggleArea.find('.pricemanager_toggle_title_hide').toggleClass('hidden');

        var opened = expandableToggleArea.find('.pricemanager_toggle_title_show').hasClass('hidden');

        // Analytics: event tracking
        trackingUtils.trackEvent('trip_information', (opened ? 'open' : 'close') +
            '_price_breakdown', Odigeo.History.getPageNameFromFragment());


        Odigeo.trigger(this.widget.id + ':heightChanged');
    },

    setSeatsLeft: function() {
        var seatsLeftTemplate = this.$el.find('.seats-left-summary');

        if (seatsLeftTemplate.length > 0) {
            var template = Odigeo._.template(seatsLeftTemplate.html(), this.templateSettings);
            var templateContent = this.$el.find('.seats_left_template_content');
            var minSeatsNumber = templateContent.data('seatsLeft');

            templateContent.html(template(this.getSeatLeftTemplate(minSeatsNumber)));

            if (!this.isTrackingSeatsLeftSent && minSeatsNumber > 0 && !Odigeo.AB.isFecoPersuasiveMessagesMobile) {
                trackingUtils.trackEvent('seats_left', 'seats_left_' + minSeatsNumber);
                this.isTrackingSeatsLeftSent = true;
            }
        }
    },

    setSavingAlert: function() {
        var savingAlert = new SavingAlertView({
            selectedPrice: this.widget.options.selectedPrice,
            averagePrice: this.widget.options.averagePrice,
            minBoundary: this.widget.options.savingAlertsMinBoundary,
            template: Odigeo._.template(this.$cachedSelectors.savingAlertsTemplate.html(), Odigeo.Utils.getTmplSettings({variable: ''})),
            translations: this.widget.options.translations,
            tests: Odigeo._.get(this.widget.options, 'tests'),
        });
        savingAlert.render();
        this.$cachedSelectors.savingAlertWrapper.html(savingAlert.$el);
    },

    getSeatLeftTemplate: function(seatsLeftNumber) {
        var isUnknown = this.widget.options.tests.isSeatLeftsCopyUpdatesMobileEnabled && seatsLeftNumber >= 9;

        return {
            numSeatsLeft: seatsLeftNumber,
            numSeatsLeftText: this.widget.options.seatsTranslations['seatsLeftMsg' + (isUnknown ? 'More' : '')],
        };
    },

    toggleInsuranceAsterisk: function(toggle) {
        this.$el.find('.pricebreakdown_message_insurance').toggleClass('hidden', toggle);
    },

    showCcNameSelected: function(params) {
        this.ccSelected = params.ccName;
        var showCcType = (!Odigeo._.isEmpty(params.ccName) && params.resolved) ||
            (!Odigeo._.isEmpty(params.ccName) && !params.resolved && !this.isPriceWithoutDiscountSelected);
        Odigeo.trigger(this.widget.id + ':toggleCcType', showCcType);
        this.$el.find('.show_cc_type').toggleClass('odf-hidden', !showCcType);
        this.$el.find('.show_cc_name').html(params.ccName);
    },

    updateFlag: function(params) {
        this[params.flag] = params.value;
    },

    showPaymentMethodDisclaimer: function(params) {
        var showCcType = (!Odigeo._.isEmpty(params.ccName) && params.resolved) ||
            (!Odigeo._.isEmpty(params.ccName) && !params.resolved && !this.isPriceWithoutDiscountSelected);
        this.$el.toggleClass('hidden-cctype', !showCcType);
        Odigeo.trigger(this.widget.id + ':toggleCcType', showCcType);
    },

    showPayWithGuarantee: function() {
        this.togglePayWithGuarantee(true);
    },

    hidePayWithGuarantee: function() {
        this.togglePayWithGuarantee(false);
    },

    setPayWithGuaranteeTrackingConditionsData() {
        this.$el.find(this.selectors.pwgConditionsLinkMoved).html(this.model.get('pwgLink'));
    },

    onPwgConditionsLinkMovedClicked() {
        const policy = this.model.get('policy');
        const trackLabel = `link_data_${policy}_policy_open`;
        if (policy !== 'standard') {
            trackingUtils.trackEvent('payment_details', trackLabel);
        }
    },

    togglePayWithGuarantee: function(showIt) {
        isPayWithGuarantee = showIt;
        var $container = this.$cachedSelectors.pricebreakdownContainer;
        var $opened = $container.hasClass('expanded');
        this.$cachedSelectors.pricebreakdownContainer.toggleClass('od-pricebreakdown-one-price', !showIt)
            .toggleClass('agree_cond_one_button', !showIt)
            .toggleClass('agree_cond_two_buttons', showIt);
        this.$cachedSelectors.payWithGuaranteeContainer.toggleClass('odf-hidden', !showIt);
        this.$cachedSelectors.tableColumn.toggleClass('odf-col-span6', showIt).toggleClass('odf-col-span8', !showIt);
        this.$cachedSelectors.priceColumn.toggleClass('odf-col-span6', showIt).toggleClass('odf-col-span4', !showIt);
        this.$cachedSelectors.paymentButton.toggleClass('odf-btn-lg odf-btn-secondary od-pay-guarantee-button-height', showIt)
            .toggleClass('odf-btn-primary', !showIt);
        this.$cachedSelectors.priceWithoutGuarantee.toggleClass('odf-hidden', !showIt);
        this.toggleTotalPriceContainer();
        this.$cachedSelectors.paymentButtonsBox.toggleClass('od-payment-buttons-box', showIt).toggleClass('od-payment-continue-box', !showIt);
        this.moveAgreeCheckbox(!$opened);

        this.$cachedSelectors.paymentButton.data(flowTrackingDefinition.TRACK_ID, showIt ? 'pay:normaldouble' : 'pay:normal');
    },

    toggleTotalPriceContainer() {
        const toHide = isPayWithGuarantee || hideTotalPrice;
        this.$cachedSelectors.totalPriceTemplate.toggleClass('odf-hidden', toHide);
        this.$el.find('.pay_with_guarantee_total_price').toggleClass('odf-hidden', !toHide);
        this.$cachedSelectors.pwgConditionsLinkMoved.toggleClass('odf-hidden', !toHide);
        this.$cachedSelectors.pwgConditionsLink.toggleClass('odf-hidden', toHide);
    },

    hideTotalPriceContainer(toggle = false) {
        hideTotalPrice = toggle;
        this.toggleTotalPriceContainer();
    },

    showAutoApplyDiscountLabel(isAutoApplyDiscount) {
        this.model.set('isAutoApplyDiscount', isAutoApplyDiscount);
        this.$cachedSelectors.autoApplyDiscountContainer.toggleClass('odf-hidden', !isAutoApplyDiscount);
    },
});
